// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectListFooter-selectInputBase__QmbDd,.SelectListFooter-menuItemBase__huyeo{display:flex;justify-content:stretch;padding:var(--size-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectInputBase": "SelectListFooter-selectInputBase__QmbDd",
	"menuItemBase": "SelectListFooter-menuItemBase__huyeo"
};
export default ___CSS_LOADER_EXPORT___;
